import React from 'react';
import { ReactionCounts, ReactionType } from '../types/event';

interface EventFooterBarProps {
  isLive: boolean;
  isReadOnly?: boolean;
  capacityMessage: string | null;
  reactionCounts: ReactionCounts;
  reacted: Record<ReactionType, boolean>;
  onReact: (type: ReactionType) => void;
  spectatorCount?: number;
  narrationAvailable?: boolean;
  narrationEnabled?: boolean;
  onToggleNarration?: () => void;
}

const EventFooterBar: React.FC<EventFooterBarProps> = ({
  isLive,
  isReadOnly = false,
  capacityMessage,
  reactionCounts,
  reacted,
  onReact,
  spectatorCount,
  narrationAvailable = false,
  narrationEnabled = false,
  onToggleNarration,
}) => (
  <div className="event-footer-bar">
    <div className="footer-status-badge">
      {isReadOnly ? '📼 Finished' : isLive ? '🟢 Live' : '⏳ Waiting'}
    </div>

    {!isReadOnly && spectatorCount !== undefined && spectatorCount > 0 && (
      <div className="footer-spectator-count" title="Spectators watching now">
        👁 {spectatorCount}
      </div>
    )}

    {capacityMessage && <div className="footer-capacity">{capacityMessage}</div>}

    {!isReadOnly && narrationAvailable && (
      <button
        className={`narration-toggle-button${narrationEnabled ? ' narration-toggle-button--active' : ''}`}
        onClick={onToggleNarration}
        title={narrationEnabled ? 'Disable AI narration' : 'Enable AI narration'}
      >
        🎙️ {narrationEnabled ? 'Narration On' : 'Narration Off'}
      </button>
    )}

    {!isReadOnly && (
      <div className="footer-reactions">
        <button
          className="reaction-button"
          onClick={() => onReact('thumbs_up')}
          disabled={reacted.thumbs_up}
          title={reacted.thumbs_up ? 'You already sent a thumbs up' : 'Send a thumbs up'}
        >
          👍 <span className="reaction-count">{reactionCounts.thumbs_ups}</span>
        </button>
        <button
          className="reaction-button"
          onClick={() => onReact('heart')}
          disabled={reacted.heart}
          title={reacted.heart ? 'You already sent a heart' : 'Send a heart'}
        >
          ❤️ <span className="reaction-count">{reactionCounts.hearts}</span>
        </button>
      </div>
    )}
  </div>
);

export default EventFooterBar;
